import { cn } from "@/lib/utils";

interface PulsingLoaderProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  label?: string;
  showLabel?: boolean;
}

/**
 * CSS-based pulsing circle loader with theme colors
 * Creates an elegant double-pulse effect that cycles through theme colors
 */
export function PulsingLoader({
  className,
  label,
  showLabel = true,
}: PulsingLoaderProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-3", className)}>
      <span className="pulsing-loader" />
      {showLabel && label && (
        <div className="flex items-center gap-1">
          <p className="text-sm text-muted-foreground">{label}</p>
          <span className="loading-dots">
            <span className="dot">.</span>
            <span className="dot">.</span>
            <span className="dot">.</span>
          </span>
        </div>
      )}
    </div>
  );
}

/**
 * Full page centered loader with backdrop
 */
export function FullPageLoader({ message = "Cargando..." }: { message?: string }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <PulsingLoader size="lg" label={message} />
    </div>
  );
}

/**
 * Inline loader for sections and cards
 */
export function InlineLoader({ message }: { message?: string }) {
  return (
    <div className="flex min-h-[200px] items-center justify-center py-8">
      <PulsingLoader size="md" label={message} showLabel={!!message} />
    </div>
  );
}

/**
 * Table loader - shows in table body
 */
export function TableLoader({ message }: { message?: string }) {
  return (
    <div className="flex items-center justify-center py-12">
      <PulsingLoader size="md" label={message} showLabel={!!message} />
    </div>
  );
}
